module.exports = __webpack_public_path__ + "img/c6.7d9e16da.jpg";